/**
 * GridIcon/index.js
 * desc: grid icon
 * note: action icon via IconButton; defaults its tooltip + accessible name to the
 *       action label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const GridIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="grid icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.grid.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 20 15" xmlns="http://www.w3.org/2000/svg"><path d="M5.882 6.923H0V0h5.882v6.923zm0 8.077H0V8.077h5.882V15zm1.177 0h5.882V8.077H7.06V15zM20 15h-5.882V8.077H20V15zM7.059 6.923h5.882V0H7.06v6.923zm7.059 0V0H20v6.923h-5.882z"/></svg>
    </IconButton>
);


export default GridIcon;
